import React from 'react'

import { UndecoratedForm } from '../../../DynamicFields'

const FourthPage = ({ dynamicFields, dynamicFieldsDynamicOptions }) => (
  <UndecoratedForm
    editing
    prefix="DynFieldData"
    form="AddClientForm"
    dynamicOptions={dynamicFieldsDynamicOptions}
    fields={dynamicFields}
  />
)

export default FourthPage
